import React from 'react'

const Footer = () => {
  return (
    <footer className='footer text-center text-dark'>
        
        <div className="social-icons">

            <a target="_blank" rel="noreferrer"  href="https://github.com/rjohn151"
                className='github me-1'> 
                <i class="bi bi-github text-secondary"  style={{ fontSize: 40 }}></i>
            </a>

            <a target="_blank" rel="noreferrer" href="https://ramonejohnson.com"
                className='website me-1'>
                <i class="bi bi-display text-dark" style={{ fontSize: 40 }}></i>
            </a>

            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/ramoneeej/"
                className='instagram me-1'>
                <i class="bi bi-instagram text-danger" style={{ fontSize: 40 }}></i>
            </a>

            <a target="_blank" rel="noreferrer"  href="https://linkedin.com/in/ramone-johnson"
                className='linkedin'>
                <i class="bi bi-linkedin text-primary" style={{ fontSize: 40 }}></i>
            </a>
        </div>

    <p className='mb-0'>Designed & Built by Ramone Johnson</p>
    {/* <p>Copyright &copy; 2022 All Rights Reserved</p> */}

</footer>
    
    
  )
}

export default Footer